import type { PercentileCurvePoint } from './types'

// Source: WHO Child Growth Standards (2006)
// https://www.who.int/tools/child-growth-standards/standards/

export const weightForAgeBoys: PercentileCurvePoint[] = [
  { month: 0, p3: 2.5, p15: 2.9, p50: 3.3, p85: 3.9, p97: 4.3 },
  { month: 1, p3: 3.4, p15: 3.9, p50: 4.5, p85: 5.1, p97: 5.7 },
  { month: 2, p3: 4.4, p15: 4.9, p50: 5.6, p85: 6.3, p97: 7 },
  { month: 3, p3: 5.1, p15: 5.6, p50: 6.4, p85: 7.2, p97: 7.9 },
  { month: 4, p3: 5.6, p15: 6.2, p50: 7, p85: 7.9, p97: 8.6 },
  { month: 5, p3: 6.1, p15: 6.7, p50: 7.5, p85: 8.4, p97: 9.2 },
  { month: 6, p3: 6.4, p15: 7.1, p50: 7.9, p85: 8.9, p97: 9.7 },
  { month: 7, p3: 6.7, p15: 7.4, p50: 8.3, p85: 9.3, p97: 10.2 },
  { month: 8, p3: 7, p15: 7.7, p50: 8.6, p85: 9.6, p97: 10.5 },
  { month: 9, p3: 7.2, p15: 7.9, p50: 8.9, p85: 10, p97: 10.9 },
  { month: 10, p3: 7.5, p15: 8.2, p50: 9.2, p85: 10.3, p97: 11.2 },
  { month: 11, p3: 7.7, p15: 8.4, p50: 9.4, p85: 10.5, p97: 11.5 },
  { month: 12, p3: 7.8, p15: 8.6, p50: 9.6, p85: 10.8, p97: 11.8 },
  { month: 13, p3: 8, p15: 8.8, p50: 9.9, p85: 11.1, p97: 12.1 },
  { month: 14, p3: 8.2, p15: 9, p50: 10.1, p85: 11.3, p97: 12.4 },
  { month: 15, p3: 8.4, p15: 9.2, p50: 10.3, p85: 11.6, p97: 12.7 },
  { month: 16, p3: 8.5, p15: 9.4, p50: 10.5, p85: 11.8, p97: 12.9 },
  { month: 17, p3: 8.7, p15: 9.6, p50: 10.7, p85: 12, p97: 13.2 },
  { month: 18, p3: 8.9, p15: 9.7, p50: 10.9, p85: 12.3, p97: 13.5 },
  { month: 19, p3: 9, p15: 9.9, p50: 11.1, p85: 12.5, p97: 13.7 },
  { month: 20, p3: 9.2, p15: 10.1, p50: 11.3, p85: 12.7, p97: 14 },
  { month: 21, p3: 9.3, p15: 10.3, p50: 11.5, p85: 13, p97: 14.3 },
  { month: 22, p3: 9.5, p15: 10.5, p50: 11.8, p85: 13.2, p97: 14.5 },
  { month: 23, p3: 9.7, p15: 10.6, p50: 12, p85: 13.4, p97: 14.8 },
  { month: 24, p3: 9.8, p15: 10.8, p50: 12.2, p85: 13.7, p97: 15.1 },
  { month: 25, p3: 10, p15: 11, p50: 12.4, p85: 13.9, p97: 15.3 },
  { month: 26, p3: 10.1, p15: 11.1, p50: 12.5, p85: 14.1, p97: 15.6 },
  { month: 27, p3: 10.2, p15: 11.3, p50: 12.7, p85: 14.4, p97: 15.9 },
  { month: 28, p3: 10.4, p15: 11.5, p50: 12.9, p85: 14.6, p97: 16.1 },
  { month: 29, p3: 10.5, p15: 11.6, p50: 13.1, p85: 14.8, p97: 16.4 },
  { month: 30, p3: 10.7, p15: 11.8, p50: 13.3, p85: 15, p97: 16.6 },
  { month: 31, p3: 10.8, p15: 11.9, p50: 13.5, p85: 15.2, p97: 16.9 },
  { month: 32, p3: 10.9, p15: 12.1, p50: 13.7, p85: 15.5, p97: 17.1 },
  { month: 33, p3: 11.1, p15: 12.2, p50: 13.8, p85: 15.7, p97: 17.3 },
  { month: 34, p3: 11.2, p15: 12.4, p50: 14, p85: 15.9, p97: 17.6 },
  { month: 35, p3: 11.3, p15: 12.5, p50: 14.2, p85: 16.1, p97: 17.8 },
  { month: 36, p3: 11.4, p15: 12.7, p50: 14.3, p85: 16.3, p97: 18 },
  { month: 37, p3: 11.6, p15: 12.8, p50: 14.5, p85: 16.5, p97: 18.3 },
  { month: 38, p3: 11.7, p15: 12.9, p50: 14.7, p85: 16.7, p97: 18.5 },
  { month: 39, p3: 11.8, p15: 13.1, p50: 14.8, p85: 16.9, p97: 18.7 },
  { month: 40, p3: 11.9, p15: 13.2, p50: 15, p85: 17.1, p97: 19 },
  { month: 41, p3: 12.1, p15: 13.4, p50: 15.2, p85: 17.3, p97: 19.2 },
  { month: 42, p3: 12.2, p15: 13.5, p50: 15.3, p85: 17.5, p97: 19.4 },
  { month: 43, p3: 12.3, p15: 13.6, p50: 15.5, p85: 17.7, p97: 19.7 },
  { month: 44, p3: 12.4, p15: 13.8, p50: 15.7, p85: 17.9, p97: 19.9 },
  { month: 45, p3: 12.5, p15: 13.9, p50: 15.8, p85: 18.1, p97: 20.1 },
  { month: 46, p3: 12.7, p15: 14.1, p50: 16, p85: 18.3, p97: 20.4 },
  { month: 47, p3: 12.8, p15: 14.2, p50: 16.2, p85: 18.5, p97: 20.6 },
  { month: 48, p3: 12.9, p15: 14.3, p50: 16.3, p85: 18.7, p97: 20.9 },
  { month: 49, p3: 13, p15: 14.5, p50: 16.5, p85: 18.9, p97: 21.1 },
  { month: 50, p3: 13.1, p15: 14.6, p50: 16.7, p85: 19.1, p97: 21.3 },
  { month: 51, p3: 13.3, p15: 14.7, p50: 16.8, p85: 19.3, p97: 21.6 },
  { month: 52, p3: 13.4, p15: 14.9, p50: 17, p85: 19.5, p97: 21.8 },
  { month: 53, p3: 13.5, p15: 15, p50: 17.2, p85: 19.7, p97: 22.1 },
  { month: 54, p3: 13.6, p15: 15.2, p50: 17.3, p85: 19.9, p97: 22.3 },
  { month: 55, p3: 13.7, p15: 15.3, p50: 17.5, p85: 20.1, p97: 22.5 },
  { month: 56, p3: 13.8, p15: 15.4, p50: 17.7, p85: 20.3, p97: 22.8 },
  { month: 57, p3: 13.9, p15: 15.6, p50: 17.8, p85: 20.5, p97: 23 },
  { month: 58, p3: 14.1, p15: 15.7, p50: 18, p85: 20.7, p97: 23.3 },
  { month: 59, p3: 14.2, p15: 15.8, p50: 18.2, p85: 20.9, p97: 23.5 },
  { month: 60, p3: 14.3, p15: 16, p50: 18.3, p85: 21.1, p97: 23.8 }
]

export const weightForAgeGirls: PercentileCurvePoint[] = [
  { month: 0, p3: 2.4, p15: 2.8, p50: 3.2, p85: 3.7, p97: 4.2 },
  { month: 1, p3: 3.2, p15: 3.6, p50: 4.2, p85: 4.8, p97: 5.4 },
  { month: 2, p3: 4, p15: 4.5, p50: 5.1, p85: 5.9, p97: 6.5 },
  { month: 3, p3: 4.6, p15: 5.1, p50: 5.8, p85: 6.7, p97: 7.4 },
  { month: 4, p3: 5.1, p15: 5.6, p50: 6.4, p85: 7.3, p97: 8.1 },
  { month: 5, p3: 5.5, p15: 6.1, p50: 6.9, p85: 7.8, p97: 8.7 },
  { month: 6, p3: 5.8, p15: 6.4, p50: 7.3, p85: 8.3, p97: 9.2 },
  { month: 7, p3: 6.1, p15: 6.7, p50: 7.6, p85: 8.7, p97: 9.6 },
  { month: 8, p3: 6.3, p15: 7, p50: 7.9, p85: 9, p97: 10 },
  { month: 9, p3: 6.6, p15: 7.3, p50: 8.2, p85: 9.3, p97: 10.4 },
  { month: 10, p3: 6.8, p15: 7.5, p50: 8.5, p85: 9.6, p97: 10.7 },
  { month: 11, p3: 7, p15: 7.7, p50: 8.7, p85: 9.9, p97: 11 },
  { month: 12, p3: 7.1, p15: 7.9, p50: 8.9, p85: 10.2, p97: 11.3 },
  { month: 13, p3: 7.3, p15: 8.1, p50: 9.2, p85: 10.4, p97: 11.6 },
  { month: 14, p3: 7.5, p15: 8.3, p50: 9.4, p85: 10.7, p97: 11.9 },
  { month: 15, p3: 7.7, p15: 8.5, p50: 9.6, p85: 10.9, p97: 12.2 },
  { month: 16, p3: 7.8, p15: 8.7, p50: 9.8, p85: 11.2, p97: 12.5 },
  { month: 17, p3: 8, p15: 8.8, p50: 10, p85: 11.4, p97: 12.7 },
  { month: 18, p3: 8.2, p15: 9, p50: 10.2, p85: 11.6, p97: 13 },
  { month: 19, p3: 8.3, p15: 9.2, p50: 10.4, p85: 11.9, p97: 13.3 },
  { month: 20, p3: 8.5, p15: 9.4, p50: 10.6, p85: 12.1, p97: 13.5 },
  { month: 21, p3: 8.7, p15: 9.6, p50: 10.9, p85: 12.4, p97: 13.8 },
  { month: 22, p3: 8.8, p15: 9.8, p50: 11.1, p85: 12.6, p97: 14.1 },
  { month: 23, p3: 9, p15: 9.9, p50: 11.3, p85: 12.8, p97: 14.3 },
  { month: 24, p3: 9.2, p15: 10.1, p50: 11.5, p85: 13.1, p97: 14.6 },
  { month: 25, p3: 9.3, p15: 10.3, p50: 11.7, p85: 13.3, p97: 14.9 },
  { month: 26, p3: 9.5, p15: 10.5, p50: 11.9, p85: 13.6, p97: 15.2 },
  { month: 27, p3: 9.6, p15: 10.7, p50: 12.1, p85: 13.8, p97: 15.4 },
  { month: 28, p3: 9.8, p15: 10.8, p50: 12.3, p85: 14, p97: 15.7 },
  { month: 29, p3: 10, p15: 11, p50: 12.5, p85: 14.3, p97: 16 },
  { month: 30, p3: 10.1, p15: 11.2, p50: 12.7, p85: 14.5, p97: 16.2 },
  { month: 31, p3: 10.3, p15: 11.3, p50: 12.9, p85: 14.7, p97: 16.5 },
  { month: 32, p3: 10.4, p15: 11.5, p50: 13.1, p85: 15, p97: 16.8 },
  { month: 33, p3: 10.5, p15: 11.7, p50: 13.3, p85: 15.2, p97: 17 },
  { month: 34, p3: 10.7, p15: 11.8, p50: 13.5, p85: 15.4, p97: 17.3 },
  { month: 35, p3: 10.8, p15: 12, p50: 13.7, p85: 15.7, p97: 17.6 },
  { month: 36, p3: 11, p15: 12.1, p50: 13.9, p85: 15.9, p97: 17.8 },
  { month: 37, p3: 11.1, p15: 12.3, p50: 14, p85: 16.1, p97: 18.1 },
  { month: 38, p3: 11.2, p15: 12.5, p50: 14.2, p85: 16.3, p97: 18.4 },
  { month: 39, p3: 11.4, p15: 12.6, p50: 14.4, p85: 16.6, p97: 18.6 },
  { month: 40, p3: 11.5, p15: 12.8, p50: 14.6, p85: 16.8, p97: 18.9 },
  { month: 41, p3: 11.6, p15: 12.9, p50: 14.8, p85: 17, p97: 19.2 },
  { month: 42, p3: 11.8, p15: 13.1, p50: 15, p85: 17.3, p97: 19.5 },
  { month: 43, p3: 11.9, p15: 13.2, p50: 15.2, p85: 17.5, p97: 19.7 },
  { month: 44, p3: 12, p15: 13.4, p50: 15.3, p85: 17.7, p97: 20 },
  { month: 45, p3: 12.1, p15: 13.5, p50: 15.5, p85: 17.9, p97: 20.3 },
  { month: 46, p3: 12.3, p15: 13.7, p50: 15.7, p85: 18.2, p97: 20.6 },
  { month: 47, p3: 12.4, p15: 13.8, p50: 15.9, p85: 18.4, p97: 20.8 },
  { month: 48, p3: 12.5, p15: 14, p50: 16.1, p85: 18.6, p97: 21.1 },
  { month: 49, p3: 12.6, p15: 14.1, p50: 16.3, p85: 18.9, p97: 21.4 },
  { month: 50, p3: 12.8, p15: 14.3, p50: 16.4, p85: 19.1, p97: 21.7 },
  { month: 51, p3: 12.9, p15: 14.4, p50: 16.6, p85: 19.3, p97: 22 },
  { month: 52, p3: 13, p15: 14.5, p50: 16.8, p85: 19.5, p97: 22.2 },
  { month: 53, p3: 13.1, p15: 14.7, p50: 17, p85: 19.8, p97: 22.5 },
  { month: 54, p3: 13.2, p15: 14.8, p50: 17.2, p85: 20, p97: 22.8 },
  { month: 55, p3: 13.4, p15: 15, p50: 17.3, p85: 20.2, p97: 23.1 },
  { month: 56, p3: 13.5, p15: 15.1, p50: 17.5, p85: 20.4, p97: 23.3 },
  { month: 57, p3: 13.6, p15: 15.3, p50: 17.7, p85: 20.7, p97: 23.6 },
  { month: 58, p3: 13.7, p15: 15.4, p50: 17.9, p85: 20.9, p97: 23.9 },
  { month: 59, p3: 13.8, p15: 15.5, p50: 18, p85: 21.1, p97: 24.2 },
  { month: 60, p3: 14, p15: 15.7, p50: 18.2, p85: 21.3, p97: 24.4 }
]
